import React, { useEffect, useState } from 'react';
import { Form, Stack } from 'react-bootstrap';

export const HpSelect = (props) => {
  const {
    label,
    editProfile,
    clinic,
    onInputChange,
    healthProfessionals: healthProfessionalsOptions,
  } = props;

  const initializeSelectMeta = () => {
    // if (clinic && clinic.episodes && clinic.episodes.length > 0) {
    //   const latestEpisode = clinic.episodes[clinic.episodes.length - 1];
    //   if (latestEpisode && latestEpisode.details && Array.isArray(latestEpisode.details.healthProfessionals)) {
    //     return latestEpisode.details.healthProfessionals;
    //   }
    // }
    // move to client_clinic_episode so change to access method. But keep above code for reference
    return clinic?.episodes[0]?.details?.healthProfessionals ?? [];
  };

  const [selectMeta, setSelectMeta] = useState(initializeSelectMeta());
  const [clinicContext, setClinic] = useState(clinic || {});

  function hpSync(temp) {
    if (
      !temp.episodes ||
      !Array.isArray(temp.episodes) ||
      temp.episodes.length === 0
    ) {
      temp.episodes = [{ details: {} }];
    }
    const latestEpisode = temp.episodes[temp.episodes.length - 1];
    if (!latestEpisode.details) {
      latestEpisode.details = {};
    }
    latestEpisode.details.healthProfessionals = selectMeta.filter(
      (hp) => hp && hp !== '-',
    );
    return temp;
  }

  const addSelectMeta = () => {
    let temp = JSON.parse(JSON.stringify(clinicContext));
    const newSelectMeta = [...selectMeta, '-'];
    setSelectMeta(newSelectMeta);
    temp = hpSync({
      ...temp,
      episodes: [{ details: { healthProfessionals: newSelectMeta } }],
    });
    setClinic(temp);
    onInputChange({
      target: { name: 'healthProfessionals', value: newSelectMeta },
    });
  };

  const removeSelectMeta = (i) => {
    const newSelectMeta = [...selectMeta];
    newSelectMeta.splice(i, 1);
    setSelectMeta(newSelectMeta);
    let temp = JSON.parse(JSON.stringify(clinicContext));
    temp = hpSync({
      ...temp,
      episodes: [{ details: { healthProfessionals: newSelectMeta } }],
    });

    setClinic(temp);
    onInputChange({
      target: { name: 'healthProfessionals', value: newSelectMeta },
    });
  };

  const handleInputChange = (e) => {
    const name = e.target ? e.target.name : 'healthProfessionals';
    const value = e.target ? e.target.value : e;

    let tempMeta = [...selectMeta];
    if (name.includes('healthProfessional')) {
      const i = parseInt(name.split('healthProfessional')[1], 10);
      tempMeta[i] = value;
    } else {
      tempMeta = value;
    }
    setSelectMeta(tempMeta);

    let temp = JSON.parse(JSON.stringify(clinicContext));
    temp = hpSync({
      ...temp,
      episodes: [{ details: { healthProfessionals: tempMeta } }],
    });

    setClinic(temp);
    onInputChange({ target: { name: 'healthProfessionals', value: tempMeta } });
  };

  useEffect(() => {
    if (!editProfile) {
      const selectedHP = initializeSelectMeta();
      setSelectMeta(selectedHP);
    }
  }, [editProfile, clinic]);

  return (
    <Stack direction="horizontal" gap={2} className="labelRow">
      <Form.Label className="labelBold">{label}</Form.Label>
      {!editProfile && (
        <Form.Group controlId="">
          {Array.isArray(selectMeta) > 0 ? (
            selectMeta.map((hp, i) => (
              <React.Fragment key={hp + '' + i}>
                {hp && (
                  <>
                    <Form.Label className="labelSimple">{hp}</Form.Label>
                    <br />
                  </>
                )}
              </React.Fragment>
            ))
          ) : (
            <label className="labelSimple">-</label>
          )}
        </Form.Group>
      )}

      {editProfile && (
        <Stack direction="vertical" gap={1} className="w100">
          {Array.isArray(selectMeta) &&
            selectMeta.map((hp, i) => (
              <React.Fragment key={i}>
                <Form.Group controlId="" className="">
                  <Stack direction="horizontal" gap={1} className="w100">
                    <Form.Select
                      className="form-select-xs mb-1"
                      onChange={handleInputChange}
                      name={
                        'clinic' +
                        (clinic?.id || '') +
                        '_healthProfessional' +
                        i
                      }
                      id={
                        'clinic' +
                        (clinic?.id || '') +
                        '_healthProfessional' +
                        i
                      }
                      value={hp || ''}
                    >
                      <option value="">-</option>
                      {(healthProfessionalsOptions || []).map((option, j) => (
                        <option key={j} value={option}>
                          {option}
                        </option>
                      ))}
                    </Form.Select>

                    {selectMeta.length > 1 && (
                      <button
                        type="button"
                        className="btn btnField p-0 "
                        onClick={() => removeSelectMeta(i)}
                      >
                        <i className="fa-solid fa-square-minus fa-md"></i>
                      </button>
                    )}
                  </Stack>
                </Form.Group>
              </React.Fragment>
            ))}

          <button
            type="button"
            className="btn btnField p-0"
            style={{ alignSelf: 'start' }}
            onClick={addSelectMeta}
          >
            <i className="fa-solid fa-square-plus fa-md"></i>
          </button>
        </Stack>
      )}
    </Stack>
  );
};
